<template>
  <div class="full-size">
    <div v-if="!isPresentingOrBackstage && !sharePresentation" class="full-size">
      <CanvasHints v-if="isCanvasHintsVisible" />
      <CustomBarChart v-if="slideActive.SlideOptions.length" />
    </div>
    <div class="full-size" v-if="isPresentingOrBackstage && !sharePresentation">
      <QuizSlideContent />
    </div>
    <div v-if="sharePresentation" class="full-size">
      <CustomBarChart v-if="slideActive.SlideOptions.length" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import QuizSlideContent from '@/components/presentations/contents/QuizSlideContent.vue'
import CanvasHints from '@/components-v2/presentation-editor/middle/hints/CanvasHints.vue'
import CustomBarChart from '@/components/presentations/charts/CustomBarChart.vue'

export default {
  components: {
    QuizSlideContent,
    CanvasHints,
    CustomBarChart,
  },
  props: {
    isCanvasHintsVisible: {
      type: Boolean,
      default: false,
    },
    sharePresentation: {
      type: Boolean,
      default: false,
    },
    isPresentingOrBackstage: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
    }),
  },
}
</script>
